module.exports = __webpack_public_path__ + "dae3a00f729e5fae7fad7dc40cf40eae.pdf";